import { RouteConfig, UserType } from "@platform/types";

import { getRoutes } from "../constants/router";

const filterRoutes = (
  routes: RouteConfig[],
  userType: UserType,
): RouteConfig[] =>
  routes.reduce((acc: RouteConfig[], route) => {
    const { roles, children, ...rest } = route;

    if (!roles || roles.includes(userType)) {
      const newRoute: RouteConfig = { ...rest, roles };
      if (children) {
        newRoute.children = filterRoutes(children, userType);
      }
      acc.push(newRoute);
    }

    return acc;
  }, []);

// Brokers and agents get the RFP details view (V2 tree); every other role,
// including broker_analyst, keeps the analyst workbench tree — see
// SignedInUser.isBrokerOrAgent in @platform/user for why that split is narrow.
export const newRoutesPerRole = (
  userType: UserType | undefined,
  isBrokerOrAgent: boolean,
  enablePropelx: boolean,
  enableRumiLaunchpad = false,
): RouteConfig[] => {
  if (!userType) {
    return [];
  }
  const routes = getRoutes(isBrokerOrAgent, {
    enablePropelx,
    enableRumiLaunchpad,
  });
  return filterRoutes(routes, userType);
};
